import { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector, useDispatch } from 'react-redux';
import CustomGridToolbar from '../../../../components/datagrid/GridToolBar';
import { deleteOrInactivePolicy, getAllHrPolicies, getRootPolicy } from '../../../../redux/features/hrPolicySlice';
import CreatePolicy from './CreatePolicy';
import { getAllUsers } from '../../../../redux/features/foodSlice';
import { getAlldepartments } from '../../../../redux/features/permissionSlice';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Switch } from '@mui/material';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
// import HrPolicy from '../../../user/EmployeeServices/HrPolicy/HrPolicy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const AdminHrPolicy = () => {
  const [gridSize, setGridSize] = useState(10);
  const [typeId, setTypeId] = useState(-1);
  const { loading, allPolicies, rootPolicies } = useSelector((state) => state.hrPolicy);
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  useEffect(() => {
    dispatch(getAllHrPolicies(-1));
    dispatch(getRootPolicy());
    dispatch(getAllUsers());
    dispatch(getAlldepartments());
  }, []);

  useEffect(() => {
    dispatch(getAllHrPolicies(typeId));
  }, [typeId]);

  const columns = [
    { field: 'hr_policy_id', headerName: 'ID', width: 20 },
    //   { field: "hr_policy_type_id", headerName: "Policy Type ID", width: 120 },
    { field: 'mapping_id_name', headerName: 'Policy For', width: 250 },
    { field: 'hr_policy_type_name', headerName: 'Policy Type', width: 200 },
    { field: 'root_policy_type_name', headerName: 'Root Type', width: 200 },
    {
      field: 'hr_policy_document_path',
      headerName: 'Document',
      width: 200,
      renderCell: (params) => (
        <Button
          variant="outlined"
          size="small"
          endIcon={<OpenInNewIcon />}
          onClick={() => {
            if (params.value) {
              window.open(`${process.env.REACT_APP_UPLOADS_URL}/${params.value}`, '_blank', 'noopener,noreferrer');
            }
          }}
        >
          Open
        </Button>
      ),
    },
    {
      field: 'hr_policy_effective_date',
      headerName: 'Effective Date',
      width: 150,
    },
    { field: 'hr_policy_expiry_date', headerName: 'Expiry Date', width: 150 },
    // { field: "hr_policy_mapping_id", headerName: "Mapping ID", width: 120 },

    { field: 'hr_policy_created_by', headerName: 'Created By', width: 120 },
    { field: 'hr_policy_created_on', headerName: 'Created On', width: 170 },
    { field: 'hr_policy_updated_by', headerName: 'Updated By', width: 120 },
    { field: 'hr_policy_updated_on', headerName: 'Updated On', width: 170 },
    {
      field: 'hr_policy_status',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => {
        return (
          <Switch
            checked={params.row.hr_policy_status == 1 ? true : false}
            onChange={(e) => {
              const data = {
                policyId: params.row.hr_policy_id,
                status: params.row.hr_policy_status == 1 ? 0 : 1,
              };
              dispatch(deleteOrInactivePolicy(data)).then((res) => {
                handleApiResponse(res, {
                  onSuccess: () => {
                    dispatch(getAllHrPolicies(typeId));
                  },
                  onFailed: () => {
                    console.log('Something went wrong');
                  },
                });
              });
            }}
            color="primary"
          />
        );
      },
    },
  ];
  return (
    <GlobalWrapper title={'HR Policy'} actions={<CreatePolicy typeId={typeId} />}>
      <Box sx={{ mb: 2 }}>
        <FormControl sx={{ width: '30%' }}>
          <InputLabel id="root-select-label">Root Policy Type</InputLabel>
          <Select
            size="small"
            labelId="root-select-label"
            name="rootId"
            label="Root Policy Type"
            value={typeId}
            onChange={(e) => {
              const value = e.target.value;
              setTypeId(value);
            }}
          >
            {[{ root_policy_type_id: -1, root_policy_type_name: 'All' }, ...rootPolicies].map((item) => (
              <MenuItem key={item.root_policy_type_id} value={item.root_policy_type_id}>
                {item.root_policy_type_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <DataGrid
        components={{ Toolbar: CustomGridToolbar }}
        rows={allPolicies}
        columns={columns}
        loading={loading}
        getRowHeight={() => 'auto'}
        getRowId={(row) => row.serialNumber}
        pageSize={gridSize}
        autoHeight
        rowsPerPageOptions={[5, 10, 25, 50]}
        onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
      />
    </GlobalWrapper>
  );
};

export default AdminHrPolicy;
